import { render, staticRenderFns } from "./info-unit.vue?vue&type=template&id=2145bcf2&scoped=true"
import script from "./info-unit.vue?vue&type=script&lang=js"
export * from "./info-unit.vue?vue&type=script&lang=js"
import style0 from "./info-unit.vue?vue&type=style&index=0&id=2145bcf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145bcf2",
  null
  
)

export default component.exports